<template>
  <div class="canMain"v-loading="loading">
    <canvas class="canvasstyle" :id="'the-canvas'+nn"></canvas>
  </div>
</template>
<script>
  import PDFJS from 'pdfjs-dist'
  import {mapActions, mapGetters} from 'vuex';
  const CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.0.489/cmaps/';
  export default {
    name: 'c-pdf',
    props: ['pdfUrl', 'mainPage'],
    data() {
      return {
        pdfDoc: null, //pdfjs 生成的对象
        pageNum: 1,//
        pageRendering: false,
        pageNumPending: null,
        scale: 1,//放大倍数
        page_num: 0,//当前页数
        page_count: 0,//总页数
        maxscale:1,//最大放大倍数
        minscale: 0.8,//最小放大倍数
        loading:true,
        nn:Math.floor(Math.random()*1000+1)
      }
    },
    methods: {
      renderPage(num) { //渲染pdf1
        let vm = this;
        this.pageRendering = true;
        let canvas = document.getElementById('the-canvas'+vm.nn);
        this.pdfDoc.getPage(num).then(function (page) {
          var viewport = page.getViewport(vm.scale);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          var renderContext = {
            canvasContext: vm.ctx,
            viewport: viewport
          };
          var renderTask = page.render(renderContext);
          vm.loading = false
        });

      }
    },
    computed: {
      ctx() {
        let id = document.getElementById('the-canvas'+this.nn);
        return id.getContext('2d');
      }
    },
    mounted() {
      let vm = this;
      PDFJS.getDocument({
        url: vm.pdfUrl,
        cMapUrl: CMAP_URL,
        cMapPacked: true,
      }).then(function (pdfDoc_) { //初始化pdf
        vm.pdfDoc = pdfDoc_;
        vm.page_count = vm.pdfDoc.numPages;
        vm.renderPage(vm.pageNum);
      });
    },
    watch: {
      mainPage(n, o) {
        this.renderPage(n);
      }
    }
  }

</script>

<style type="text/less" lang="less" rel="stylesheet/less" scoped="scoped">
  .canMain{
    display: inline-block;
    .canvasList {
      text-align: center;
      height: 100%;
      overflow: auto;
      /*padding-top: 20px;*/
      /*width: 279px;*/
      float: right;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/fire/pdfMain.vue